import React from 'react';
import {
  AreaBox,
  AreaContainer,
  AreaPage,
  BoxHeader,
  BoxText,
  Li,
  LiGlobal,
  BoxLogoImage,
  BoxForLogo,
} from './AreaOfUseElements';

import logo from '../../../img/jenbacherinnio.png';

import { useLanguage } from '../../../hooks';
import { MainPageText } from '../../Library/LibraryMainPage';

const AreaOfUse = () => {
  const { lang } = useLanguage();
  return (
    <AreaPage id="areaofuse">
      <AreaContainer>
        <AreaBox>
          <BoxHeader>{MainPageText[lang].aouLeftH}</BoxHeader>
          <BoxText>
            <ul></ul>
            <LiGlobal>{MainPageText[lang].aouLeftT1}</LiGlobal>

            <LiGlobal>{MainPageText[lang].aouLeftT2}</LiGlobal>

            <LiGlobal>{MainPageText[lang].aouLeftT3}</LiGlobal>
            <Li>{MainPageText[lang].aouLeftLi1}</Li>
            <Li>{MainPageText[lang].aouLeftLi2}</Li>
            <Li>{MainPageText[lang].aouLeftLi3}</Li>
            <Li>{MainPageText[lang].aouLeftLi4}</Li>
            <Li>{MainPageText[lang].aouLeftLi5}</Li>

            <LiGlobal>{MainPageText[lang].aouLeftT4}</LiGlobal>
          </BoxText>
          <BoxText>{MainPageText[lang].aouLeftT5}</BoxText>
          <BoxText>{MainPageText[lang].aouLeftT6}</BoxText>
          <BoxText>{MainPageText[lang].aouLeftT7}</BoxText>
        </AreaBox>
        <AreaBox>
          <BoxHeader>{MainPageText[lang].aouRightH}</BoxHeader>
          <BoxText>
            <Li> {MainPageText[lang].aouRightLi1}</Li>
            <Li> {MainPageText[lang].aouRightLi2}</Li>
            <Li> {MainPageText[lang].aouRightLi3}</Li>
            <Li> {MainPageText[lang].aouRightLi4}</Li>
          </BoxText>
          <BoxForLogo>
            <BoxLogoImage src={logo} />
          </BoxForLogo>
        </AreaBox>
      </AreaContainer>
    </AreaPage>
  );
};

export default AreaOfUse;
